module.exports = __webpack_public_path__ + "static/media/excel-animation.ef1e7343.gif";